<template>
  <section class="menu-preview main-contents-wrapper">
    <h2>{{ title }}</h2>
    <p class="sample-note">샘플 화면 · 운영 데이터와 연결되지 않습니다. 저장·신청·승인·지급·회수는 실행하지 않습니다.</p>
    <form v-if="isForm" class="sample-form" @submit.prevent="notice = '데모에서는 저장하지 않습니다.'">
      <label v-for="field in fields" :key="field.label">
        <span>{{ field.label }}</span>
        <select v-if="field.options" v-model="field.value"><option v-for="option in field.options" :key="option">{{ option }}</option></select>
        <input v-else v-model="field.value" :type="field.type || 'text'" autocomplete="off" />
      </label>
      <button class="btn btn-blue" type="submit">저장 (테스트)</button>
      <p role="status">{{ notice }}</p>
    </form>
    <form v-else class="sample-search" @submit.prevent="currentPage = 1">
      <label>검색 <input v-model="search" placeholder="아이디·내용 검색" @input="currentPage = 1" /></label>
      <label>시작일 <input v-model="startDate" type="date" @change="currentPage = 1" /></label>
      <label>종료일 <input v-model="endDate" type="date" @change="currentPage = 1" /></label>
      <button class="btn btn-blue" type="submit">조회</button>
    </form>
    <template v-if="!isForm">
      <p class="result-count">검색 결과 {{ filteredRows.length }}건</p>
      <div class="sample-table">
        <table class="mainTable">
          <thead><tr><th v-for="column in columns" :key="column.key">{{ column.label }}</th><th v-if="isBoard">상세</th></tr></thead>
          <tbody>
            <tr v-for="(row, i) in visibleRows" :key="i">
              <td v-for="column in columns" :key="column.key">{{ format(row[column.key]) }}</td>
              <td v-if="isBoard"><button class="btn btn-blue" @click="selected = row">보기</button></td>
            </tr>
            <tr v-if="!visibleRows.length"><td :colspan="columns.length + (isBoard ? 1 : 0)">데이터가 없습니다.</td></tr>
          </tbody>
        </table>
      </div>
      <div class="sample-pagination">
        <button :disabled="currentPage === 1" @click="currentPage--">이전</button>
        <span>{{ currentPage }} / {{ pageCount }}</span>
        <button :disabled="currentPage === pageCount" @click="currentPage++">다음</button>
      </div>
      <article v-if="selected" class="sample-detail">
        <h3>{{ selected.title }}</h3><p>{{ selected.content }}</p><button @click="selected = null">닫기</button>
      </article>
    </template>
  </section>
</template>
<script>
import { members, bets, totals } from './api.cjs'

export default {
  data () {
    return { search: '', startDate: '', endDate: '', currentPage: 1, selected: null, notice: '', fields: [] }
  },
  computed: {
    title () { return this.$route.meta.text || '관리자 기능' },
    group () { return this.$route.meta.demoGroup },
    isBoard () { return this.group === 'board' },
    isForm () { return /생성|설정|변경|등록/.test(this.title) || this.group === 'Game' || this.$route.name === 'AccBalance' },
    columns () {
      if (this.isBoard) return this.columnList(['번호', 'index'], ['아이디', 'memId'], ['제목', 'title'], ['상태', 'status'], ['등록일시', 'date'])
      if (this.group === 'betGame') return this.columnList(['아이디', 'memId'], ['게임', 'gameName'], ['베팅금액', 'betAmt'], ['당첨금액', 'betWinAmt'], ['등록일시', 'date'])
      if (this.group === 'reports') return this.columnList(['아이디', 'memId'], ['입금액', 'totalCashInAmt'], ['출금액', 'totalCashOutAmt'], ['보유머니', 'cashAmt'], ['보유포인트', 'pointAmt'], ['조회일', 'date'])
      if (['UserCashBoth', 'ptCredit', 'insured'].includes(this.group) || /포인트|캐시|지급|회수/.test(this.title)) return this.columnList(['아이디', 'memId'], ['내용', 'content'], ['처리 전', 'before'], ['변동금액', 'amount'], ['처리 후', 'after'], ['상태', 'status'], ['처리일시', 'date'])
      if (this.group === 'admin') return this.columnList(['관리자 아이디', 'memId'], ['내용', 'content'], ['접속 IP', 'ip'], ['등록일시', 'date'])
      if (this.group === 'Partner' || this.group === 'company') return this.columnList(['아이디', 'memId'], ['닉네임', 'memNick'], ['등급', 'level'], ['하부회원', 'count'], ['보유머니', 'cashAmt'], ['등록일시', 'date'])
      return this.columnList(['아이디', 'memId'], ['닉네임', 'memNick'], ['보유머니', 'cashAmt'], ['보유포인트', 'pointAmt'], ['상태', 'status'], ['접속 IP', 'ip'], ['일시', 'date'])
    },
    rows () {
      const day = members[0].regDt.slice(0, 10)
      if (this.isBoard) return Array.from({ length: 15 }, (_, i) => ({ index: i + 1, memId: members[i].memId, title: `${this.title} 샘플 ${i + 1}`, status: '확인 완료', date: `${day} 10:00:00`, content: '포트폴리오 확인용 가상 내용입니다. 실제 공지나 문의가 아닙니다.' }))
      if (this.group === 'betGame') return bets.filter(b => !['casino', 'slot', 'sport', 'mini'].includes(this.$route.meta.group) || b.gameCategory === this.$route.meta.group).map(b => ({ ...b, date: b.regDate }))
      if (this.group === 'Partner' || this.group === 'company') return Array.from({ length: 5 }, (_, i) => ({ memId: `partner${i + 1}`, memNick: `샘플파트너${i + 1}`, level: '총판', count: 7, cashAmt: members.slice(i * 7, i * 7 + 7).reduce((sum, m) => sum + m.cashAmt, 0), date: `${day} 09:00:00` }))
      if (this.group === 'admin') return [{ memId: 'admin', content: '로그인', ip: '192.0.2.1', date: `${day} 10:00:00` }]
      const entries = this.$route.name === 'loginList' ? members.slice(0, totals.memLoginCnt) : members
      return entries.map((m, i) => ({ ...m, status: '완료', content: `${this.title} 샘플`, before: m.cashAmt, amount: i % 2 ? -10000 : 10000, after: m.cashAmt + (i % 2 ? -10000 : 10000), ip: m.loginIp, date: /접속|로그인|추적|아이피/.test(this.title) ? m.lastLoginDt : m.regDt }))
    },
    filteredRows () {
      return this.rows.filter(row => (!this.search || Object.values(row).some(value => String(value).toLowerCase().includes(this.search.toLowerCase()))) && (!this.startDate || row.date.slice(0, 10) >= this.startDate) && (!this.endDate || row.date.slice(0, 10) <= this.endDate))
    },
    pageCount () { return Math.max(1, Math.ceil(this.filteredRows.length / 10)) },
    visibleRows () { return this.filteredRows.slice((this.currentPage - 1) * 10, this.currentPage * 10) }
  },
  methods: {
    columnList (...items) { return items.map(([label, key]) => ({ label, key })) },
    format (value) { return typeof value === 'number' ? value.toLocaleString() : value },
    setFields () {
      if (/생성/.test(this.title)) {
        this.fields = [{ label: '아이디', value: '' }, { label: '닉네임', value: '' }, { label: '비밀번호', value: '', type: 'password' }, { label: '등급', value: '회원', options: ['회원', '총판', '대본'] }]
      } else if (this.$route.name === 'AccBalance') {
        this.fields = [{ label: '관리자', value: 'admin' }, { label: '보유알', value: '10,000,000' }, { label: '회원 보유머니', value: totals.cashAmt.toLocaleString() }, { label: '현재 비밀번호', value: '', type: 'password' }, { label: '새 비밀번호', value: '', type: 'password' }]
      } else {
        // ponytail: settings are a labelled preview, not a replica of every production option.
        this.fields = [{ label: '설정 대상', value: this.title }, { label: '사용 여부', value: 'ON', options: ['ON', 'OFF'] }, { label: '테스트 값', value: '0' }]
      }
    }
  },
  watch: {
    '$route.fullPath' () { this.search = ''; this.startDate = ''; this.endDate = ''; this.currentPage = 1; this.selected = null; this.notice = ''; this.setFields() }
  },
  created () { this.setFields() }
}
</script>
<style scoped>
.menu-preview { padding: 30px 24px 80px; color: #edf3fa; }
h2 { font-size: 22px; margin-bottom: 16px; font-weight: 600; }
.sample-note { margin-bottom: 24px; color: #aebfd5; line-height: 1.6; }
.sample-search { display: flex; align-items: center; flex-wrap: wrap; gap: 16px; padding: 20px; background: #242c3b; }
input, select { background: #2a3343; border: 1px solid #465068; color: #fff; border-radius: 4px; padding: 10px; margin-left: 10px; }
.result-count { text-align: right; margin: 18px 0; }
.sample-table { overflow-x: auto; }
table { width: 100%; min-width: 700px; } th, td { padding: 12px; }
.sample-pagination { display: flex; gap: 16px; justify-content: center; margin: 20px; }
button { cursor: pointer; background: #3b5084; color: #fff; border: 0; border-radius: 4px; padding: 10px 16px; }
button:disabled { opacity: .4; cursor: default; }
.sample-form, .sample-detail { background: #242c3b; padding: 24px; max-width: 600px; }
.sample-form label { display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px; }
.sample-form p, .sample-detail p { margin: 18px 0; line-height: 1.6; }
</style>
